module.exports = __webpack_public_path__ + "img/spribe.4ed84c9a.jpeg";